module.exports = __webpack_public_path__ + "static/jackiewithbuddylee-c9c815ca24210be6b38197349cfa279d.jpg";